// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1881725d","453":"270b19d4","455":"a228bed8","977":"e06aeaae"}[chunkId] + ".chunk.js";
};